import { Box, Typography } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { Link, useParams } from "react-router-dom";
import {
  EPOCUS_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "../../../_lib/epocus-palette";
import { usePerformerName } from "../../../_lib/hooks/use-performer-name";
import { PerformanceHeader } from "../../../_lib/performance-header";
import { PerformerPerformance } from "../../../_lib/performer-performance";
import { PageRoot } from "../../../_lib/stat-primitives";
import { usePerformerStats } from "../../../_lib/use-performer-stats";
import { useStatsFilter } from "../../../_lib/use-stats-filter";
import { linkToEpocusProgram } from "../../../links";
import { RecentExamsTable } from "./_lib/recent-exams-table";

const BackToProgram: FC = () => (
  <Link
    to={linkToEpocusProgram()}
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 2,
      minHeight: 44,
      fontSize: rem(13),
      fontWeight: 600,
      color: EPOCUS_PRIMARY,
      textDecoration: "none",
    }}
  >
    <ChevronLeftIcon style={{ fontSize: rem(18) }} />
    Program Dashboard
  </Link>
);

export const EpocusPerformerDetailPage: FC = () => {
  const { performerId = "" } = useParams();
  const [filter, setFilter] = useStatsFilter();
  const { displayName, loading } = usePerformerName(performerId);
  const stats = usePerformerStats(performerId, filter);

  return (
    <PageRoot>
      <Box>
        <BackToProgram />
        <PerformanceHeader
          title={loading ? "Loading…" : displayName}
          subtitle="Performer · programme view"
        />
      </Box>

      {stats.hasAnyData ? (
        <PerformerPerformance
          stats={stats}
          filter={filter}
          onFilterChange={setFilter}
        >
          <RecentExamsTable exams={stats.recentExams} />
        </PerformerPerformance>
      ) : (
        <Typography style={{ fontSize: rem(14), color: EPOCUS_TEXT_SECONDARY }}>
          No performer data for this user.
        </Typography>
      )}
    </PageRoot>
  );
};
